import React, { useEffect, useState } from "react";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import { withPrefix } from "gatsby";

//react-boostrap
import {
  Navbar as NBar,
  Nav,
  NavDropdown,
  Container,
  Offcanvas,
  Button,
  Dropdown,
} from "react-bootstrap";
import ArrowToggle from "../icons/ArrowToggle";

import LogoHK from "../../data/svg/logo-full.svg";
import LogoHKSide from "../../data/svg/logo-full-side.svg";
import LogoEN from "../../data/svg/logo-full_en.svg";
import LogoENSide from "../../data/svg/logo-full_en-side.svg";

import ExternalLink from "./external-link";
import InternalLink from "./internal-link";
import { gtag } from "../../hooks/use-gtag-navigate";

const featuresLinks: INavLink[] = [
  {
    id: "header-btn-online",
    to: "/features/online-store",
    name: "menu.online_store",
  },
  {
    id: "header-features-pos",
    to: "/features/cloud-pos",
    name: "menu.pos",
  },
  {
    id: "header-features-payment-delivery",
    to: "/features/payment-and-delivery-logistics",
    name: "menu.payment",
  },
  {
    id: "header-features-inventory",
    to: "/features/inventory-management",
    name: "menu.inventory",
  },
  {
    id: "header-features-crm",
    to: "/features/crm-and-loyalty",
    name: "menu.customer",
  },
  {
    id: "header-features-social",
    to: "/features/social-commerce",
    name: "menu.social",
  },
  {
    id: "header-features-chatbot",
    to: "/features/ai-chatbot",
    name: "menu.chatbot",
  },
  {
    id: "header-features-booking",
    to: "/features/online-booking-system",
    name: "menu.online_booking",
  },
];

interface INavLink {
  id: string;
  dropdown?: boolean;
  external?: boolean;
  blank?: boolean;
  trans?: boolean;
  links?: INavLink[];
  name: string;
  to?: string;
}

const navLinks: INavLink[] = [
  {
    id: "header-feature",
    dropdown: true,
    links: featuresLinks,
    name: "menu.features",
  },
  {
    id: "header-price",
    to: "/price",
    name: "menu.price",
  },
  {
    id: "header-blog",
    to: "/blog",
    name: "menu.blog",
  },
  {
    id: "header-setup",
    to: "/store-setup",
    name: "menu.setup",
  },
  {
    id: "header-guide",
    to: "menu.userguide_url",
    trans: true,
    name: "menu.guide",
    external: true,
    blank: false,
  },
  {
    id: "header-contact",
    to: "/contact-us",
    name: "menu.contact",
  },
  {
    id: "header-btn-online",
    to: "https://www.mystoreberry.com/auth/login?click=nav-menu",
    name: "menu.login",
    external: true,
    blank: true,
  },
];

const Navbar: React.FC = () => {
  const { t, language, languages, changeLanguage } = useI18next();
  const [isScoll, setIsScoll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });
  const isSticky = () => {
    const header = document.querySelector(".navbar");
    const scrollTop = window.scrollY;
    if (header) {
      if (scrollTop >= 250) {
        header.classList.add("sticky");
        setIsScoll(true);
      } else {
        header.classList.remove("sticky");
        setIsScoll(false);
      }
    }
  };
  return (
    <NBar className="navbar" sticky="top" collapseOnSelect expand="xl">
      <Container fluid>
        <InternalLink
          onClick={() => {
            gtag();
          }}
          className="navbar__brand"
          href="/"
        >
          <NBar.Brand>
            {language === "hk" ? <LogoHK></LogoHK> : <LogoEN></LogoEN>}
          </NBar.Brand>
        </InternalLink>
        <NBar.Toggle
          className="navbar__toggle"
          aria-controls="offcanvasNavbar-expand-sm"
        >
          <i className="las la-bars" aria-hidden="true"></i>
        </NBar.Toggle>
        <NBar.Offcanvas
          id="offcanvasNavbar-expand-sm"
          aria-labelledby="offcanvasNavbarLabel-expand-sm"
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="navbar__brand"
              id="offcanvasNavbarLabel-expand-sm"
            >
              {language === "hk" ? (
                <LogoHKSide></LogoHKSide>
              ) : (
                <LogoENSide></LogoENSide>
              )}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              {navLinks.map((item) => {
                if (item.dropdown) {
                  return (
                    <Dropdown
                      className="my-2 my-lg-0"
                      key={item.id}
                      id={item.id}
                      as={Nav.Item}
                    >
                      <Dropdown.Toggle as={ArrowToggle}>
                        {t(item.name)}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {item.links &&
                          item.links.map((subItem) => {
                            if (!item.external) {
                              return (
                                <NavDropdown.Item
                                  className="my-1 navbar-active"
                                  key={subItem.id}
                                  as="div"
                                >
                                  <InternalLink
                                    onClick={()=>{gtag()}}
                                    id={subItem.id}
                                    href={subItem.to || ""}
                                    className={"nav-link dropdown-link"}
                                  >
                                    <div>{t(subItem.name)}</div>
                                  </InternalLink>
                                </NavDropdown.Item>
                              );
                            } else {
                              return (
                                <NavDropdown.Item
                                  className="my-1"
                                  key={subItem.id}
                                  as="div"
                                >
                                  <InternalLink
                                    onClick={() => {
                                      gtag();
                                    }}
                                    className="nav-link dropdown-link"
                                    id={subItem.id}
                                    href={subItem.to}
                                    target={subItem.blank ? "_blank" : "_self"}
                                  >
                                    <div>{t(subItem.name)}</div>
                                  </InternalLink>
                                </NavDropdown.Item>
                              );
                            }
                          })}
                      </Dropdown.Menu>
                    </Dropdown>
                  );
                } else if (!item.external) {
                  return (
                    <Nav.Item key={item.id}>
                      <InternalLink
                        onClick={()=>{gtag()}}
                        id={item.id}
                        href={item.to || ""}
                        className="nav-link"
                      >
                        <div>{t(item.name)}</div>
                      </InternalLink>
                    </Nav.Item>
                  );
                } else {
                  return (
                    <Nav.Item className="my-1" key={item.id}>
                      <a
                        className="nav-link"
                        id={item.id}
                        href={item.trans ? t(item.to || "") : item.to}
                        target={item.blank ? "_blank" : "_self"}
                      >
                        {t(item.name)}
                      </a>
                    </Nav.Item>
                  );
                }
              })}
              {languages && languages.length > 0 && (
                <Dropdown className="my-1 my-lg-0" as={Nav.Item}>
                  <Dropdown.Toggle as={ArrowToggle}>
                    <i className="las la-language"></i>
                    {t(language)}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {languages.map((lang) => (
                      <NavDropdown.Item
                        key={lang}
                        as="div"
                        onClick={(e) => {
                          e.preventDefault;
                          changeLanguage(lang);
                        }}
                      >
                        <a className="nav-link dropdown-link">{t(lang)}</a>
                      </NavDropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}

              <ExternalLink
                onClick={() => {
                  gtag();
                }}
                href={"https://www.mystoreberry.com/auth/registration"}
                queryParams={{ click: "nav-menu" }}
              >
                <Button className="my-3 m-lg-0 red-button">
                  {t("menu.registration")}
                </Button>
              </ExternalLink>
            </Nav>
          </Offcanvas.Body>
        </NBar.Offcanvas>
      </Container>
    </NBar>
  );
};

export default Navbar;
